import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

import "swiper/css";
import "swiper/css/navigation";
import "react-loading-skeleton/dist/skeleton.css";
import "../style/FreshArrivel.css";
import { getNewArrivals } from "../service/NewArrivals.service";
import { getHomeUrl } from "../../../utils/url.utils";

const FreshArrivals = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArrivals();
  }, []);

  const loadArrivals = async () => {
    try {
      const response = await getNewArrivals();
      setBanners(response || []);
    } catch (error) {
      console.error("Fresh Arrivals Error:", error);
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  if (!loading && banners.length === 0) return null;

  const showNavigation = banners.length > 1;

  return (
    <section className="newarrivel">
      <div className="container-fluid">
        <div className="arrival-header d-flex justify-content-between align-items-center">
          <div className="arrival-title">
               <h2>New Arrivals </h2>
               {/* <div class="border-bootemline"></div> */}
          </div>

          {/* Right Arrow */}

          {showNavigation && (
            <div className="arrival-navigation">
              <div className="swiper-button-prev custom-nav">
                <span> <i className="bi bi-chevron-left"></i></span>
              </div>

              <div className="swiper-button-next custom-nav">
                <span> <i className="bi bi-chevron-right"></i> </span>
              </div>
            </div>
          )}
        </div>

        {/* Slider */}

        <div className="banner-slider position-relative mt-2">
         <Swiper
                modules={[Navigation, Autoplay]}
                navigation={
                  showNavigation
                    ? {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                      }
                    : false
                }
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                }}
                loop={banners.length > 1}
                slidesPerView={1}
              >

            {loading ? (
              <SwiperSlide>
                <Skeleton height={400}/>
              </SwiperSlide>
            ) : (

              banners.map((banner)=>{

                const image =
                  banner.media?.find(
                    item => item.deviceType === "desktop"
                  ) || banner.media?.[0];


                return (
                  <SwiperSlide key={banner.id}>
                    <Link to={getHomeUrl(banner.buttonUrl)}>
                      <img
                        src={image?.image}
                        alt={image?.altText || "New Arrival"}
                        className="img-fluid w-100"
                        loading="lazy"
                        style={{borderRadius:"10px", height:"auto"}}

                      />
                    </Link>
                  </SwiperSlide>
                )
              })
            )}

          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FreshArrivals;